import { baseURL } from '@/config/APIConfig';
import {
    START_LOADING,
    SET_USER_DETAIL,
    UPDATE_PASSWORD,
    SET_USER_TOKEN
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';
import axios from 'axios';

/**
 * Get app data
 */
export const loadAppData = (isFirstTime = false) => {
    return (dispatch) => {
        return Promise.all([dispatch(userDataAction()),])
            .then(res => {
                return Promise.resolve(res);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    };
};


/**
 * Login Action - Uses production API via backend proxy
 * All calls go through /api/proxy/ to api.shipez.ai
 * @param {*} payload 
 * @returns 
 */
export const getLoginToken = payload => {
    return async dispatch => {
        // First get auth token from devauth via proxy
        const payloadToken = JSON.stringify({
            "username": "devauth",
            "password": "devauth@987"
        });
        
        return APICall('post', payloadToken, 'Auth/GetToken').then(async result => {
            if (result.statuscode === 200) {
                const authToken = result?.token;
                if (authToken) {
                    const udetails = await dispatch(getUserDetails(payload, authToken));
                    if (udetails) {
                        dispatch({
                            type: SET_USER_TOKEN,
                            payload: result ?? null,
                        });
                        return Promise.resolve(authToken);
                    } else {
                        return Promise.reject('User not found');
                    }
                }
            }
            return Promise.reject('Authentication failed');
        }, error => {
            console.error('Login error:', error);
            return Promise.reject(error);
        });
    };
};


/**
 * Get UserData Login - via proxy
 */
export const getUserDetails = (payload, token) => {
    return dispatch => {
        return APICall('post', payload, 'user/Login', { headers: { 'Authorization': `Bearer ${token}` } }).then(result => {
            console.log('User details result:', result);
            if (result?.statuscode === 200) {
                setAuthToken(token, '', '', result?.data);
                dispatch({
                    type: SET_USER_DETAIL,
                    payload: result?.data || {},
                });
                return result?.data;
            } else {
                return Promise.reject(result?.message || 'Login failed');
            }
        }, error => {
            console.error('getUserDetails error:', error);
            return Promise.reject(error);
        });
    };
};

/**
 * User data action placeholder
 */
export const userDataAction = () => {
    return dispatch => {
        return Promise.resolve();
    };
};
